import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { Member } from './../member';
import { MemberList } from './../member-list';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-add-member',
    templateUrl: './add-member.component.html',
    styleUrls: ['./add-member.component.css'],
    providers: [MemberService, MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter, SetAllMemberCheck, UtilityFunctions]
})
export class AddMemberComponent implements OnInit {
    private _router;
    private shouldSlide: boolean = false;
    private member: MemberList;
    private popUp = false;
    private popUpMessage: string;
    private popupTitle = 'Error';
    private memberObj: Member;
    private validate;
    private vendor;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 60;
    private height: any;
    private scrollOptions: ISlimScrollOptions;
    private divHeight = 30;
    private addMemberFlag = false;
    private memberType = ['Owner', 'Tenant'];
    private clubName = '';

    constructor(private router: Router, private memberService: MemberService, private appService: AppService,
        private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private hiddenFooter: HiddenFooter,
        private signInEvent: SignInEvent, private loaderEvent: LoaderEvent, private setAllMemberCheck: SetAllMemberCheck, private utilityFunctions: UtilityFunctions) {
        this._router = router;
        this.popUpMessage = '';
        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
        this.memberObj = {
            'emailId': '',
            'contactNumber': '',
            'membershipId': '',
            'firstName': '',
            'lastName': '',
            'type': ''
        };
       this.scrollOptions = {
           barBackground: "#343a40", barOpacity: "0.6", position: "right",
           barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        };
        this.member = {
            vendorId: '',
            members: []
        };
        this.validate = {
            'emailId': '',
            'contactNumber': '',
            'membershipId': '',
            'firstName': '',
            'lastName': '',
            'type': '',
            'flag': false
        };
    }

    ngOnInit() {
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.clubName = this.vendor.clubName;
        this.emitOpenFrameEvent();
        this.emitTypeBroadcast();
        this.registerTypeBroadcast();
    }

    /**
     * Add single member at one time in DB
     * 
     * @param member object
     * 
     * @response SUCCESS or FAILED
     */

    addMember(popUpObj) {
        let emailFlag = false;
        this.member.vendorId = this.vendor._id;
        let validationResponse = { status: 0, message: '' };
        if (this.validationForMandatoryFields('')) {
            validationResponse = this.memberService.validationViewSide(this.memberObj);
            if (validationResponse.status === 200) {
                emailFlag = this.utilityFunctions.validateEmail(this.memberObj.emailId);
                if (emailFlag) {
                    this.loaderEvent.fire(false);
                    this.member.members.push(this.memberObj);
                    this.memberService.addMember(this.member).then((result: any) => {
                        if (result.status === 'SUCCESS') {
                            this.popupTitle = 'SUCCESS';
                            this.popUp = true;
                            this.popUpMessage = result.message;
                            this.addMemberFlag = true;
                            popUpObj.showChildModal();
                        } else {
                            this.popUp = true;
                            this.popUpMessage = result.message;
                            popUpObj.showChildModal();
                        }
                        this.loaderEvent.fire(true);
                    });
                    this.member.members = [];
                } else {
                    this.popUp = true;
                    this.popUpMessage = CONSTANT_MESSAGES.REQUIRE_VALID_EMAIL_ID;
                    popUpObj.showChildModal();
                }
            } else {
                this.popUp = true;
                this.popUpMessage = validationResponse.message;
                popUpObj.showChildModal();
            }
        }
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too by broadcaster  
     */
    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }

    /**
     * function show menu at add member page by broadcaster
     */

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }

    /**
     * Got to home screen
     */

    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
     * Redirect to member page on Ok Button on pop up 
     */

    onNotify(bool: boolean) {
        if (bool && this.addMemberFlag) {
            this._router.navigate(['/member']);
        } else {
            this._router.navigate(['/addmember']);
        }
        this.addMemberFlag = false;
    }

    /**
     * Validate mandatory fields 
     */
    validationForMandatoryFields(validatePara) {
        try {
            let validateFlag = true;
            switch (validatePara) {
                case 'membershipId':
                    if (!(this.memberObj.membershipId + '').trim() || this.memberObj.membershipId === ' ') {
                        this.memberObj.membershipId = '';
                        this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        validateFlag = false;
                    } else {
                        this.validate.membershipId = '';
                    }
                    break;
                case 'emailId':
                    if (!this.utilityFunctions.validateEmail(this.memberObj.emailId)) {
                        this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        validateFlag = false;
                    } else {
                        this.validate.emailId = '';
                    }
                    break;
                case 'contactNumber':

                    if (this.utilityFunctions.validateContact(this.memberObj.contactNumber)) {
                        this.memberObj.contactNumber = this.memberObj.contactNumber.replace(/['a-zA-Z~,.<>;!@#$%^&*?':"/[\]|{}()=_]/g, '');
                    }
                    if (!(this.memberObj.contactNumber + '').trim() || this.memberObj.contactNumber.length < 4 || this.memberObj.contactNumber.length > 16) {
                        this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        validateFlag = false;
                    } else {
                        this.validate.contactNumber = '';
                    }
                    break;
                case 'firstName':
                    if (!(this.memberObj.firstName + '').trim()) {
                        this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        validateFlag = false;
                    } else {
                        this.validate.firstName = '';
                    }
                    break;
                case 'lastName':
                    if (!(this.memberObj.lastName + '').trim()) {
                        this.validate.lastName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        validateFlag = false;
                    } else {
                        this.validate.lastName = '';
                    }
                    break;
                case 'type':
                    if (!(this.memberObj.type + '').trim()) {
                        this.validate.type = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                        validateFlag = false;
                    } else {
                        this.validate.type = '';
                    }
                    break;
                case '':
                    validateFlag = this.validateMandatoryFields();
                    break;
            }
            return validateFlag;
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate compulsory member fields
     * 
     * @returns 
     * 
     * @memberof AddMemberComponent
     */
    validateMandatoryFields() {
        this.validate.flag = true;
        if (!(this.memberObj.membershipId + '').trim()) {
            this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.membershipId = '';
        }
        if (!this.utilityFunctions.validateEmail(this.memberObj.emailId)) {
            this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.emailId = '';
        }
        if (!(this.memberObj.contactNumber + '').trim() || this.utilityFunctions.validateContact(this.memberObj.contactNumber) || this.memberObj.contactNumber.length < 4 || this.memberObj.contactNumber.length > 16) {
            this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.contactNumber = '';
        }
        if (!(this.memberObj.firstName + '').trim()) {
            this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.firstName = '';
        }
        if (!(this.memberObj.lastName + '').trim()) {
            this.validate.lastName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.lastName = '';
        }
        if (!(this.memberObj.type + '').trim()) {
            this.validate.type = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.type = '';
        }
        return this.validate.flag;
    }

    resetAll() {
        this._router.navigate(['/member']);
    }

    show(p) {
        p.showChildModal();
    }
}



// WEBPACK FOOTER //
// ./src/app/member/add-member/add-member.component.ts